import React, { useState, useEffect } from "react";

import { Button, Modal } from "antd";

import "./Auth.css";

import history from "../../routes/history";
import { getCookie } from "../../shared/helpers";
import SignUpLogin from "./components/SignUpLogin";
import { isModalVisibleAuth, signUpLoginUpdate } from "../../redux/actions";
import { useDispatch } from "react-redux";
import SignUp from "./components/SignUp";

const Auth = ({signUp=false}) => {

  const dispatch = useDispatch()
  if (getCookie("RememberMe") == "true") {
    history.push("/auth");
  }

  const [dimensions, setDimensions] = useState(window.innerWidth);

  const checkDimensions = () => {
    setDimensions(window.innerWidth);
  };

  useEffect(() => {
    dispatch(isModalVisibleAuth(true));
    dispatch(signUpLoginUpdate(signUp));
    window.addEventListener("resize", checkDimensions);
  }, []);

  return (
    <div className="authorizationModal" style={{ backgroundColor: "#fafafa", }}>
      {/* <Button type="primary" onClick={showModal}>
        Open Modal
      </Button>
      <Modal
        bodyStyle={{ padding: 0 }}
        width="24.37rem"
        visible={isModalVisible}
        closable={false}
        footer={null}
        style={{ top: 45 }}
      >
        <SignUpLogin /> */}
      {/* </Modal> */}
      {dimensions < 768 && <SignUpLogin />}
    </div>
  );
};

export default Auth;
